import React, { useState, useEffect, Fragment } from "react"
import { useNavigate } from "react-router"
import { Report } from "notiflix"

import "./styles.css"
import Footer from "../../atoms/footer"
import Navbar from "../../atoms/navbar"

import { requestToken } from "../../auth/AuthServices"
import { useIsAuthenticated } from "@azure/msal-react"
import ImportantInfo from "../../atoms/important-updates"

import HeaderFarms from "../../utils/header_farms"
import { Empty, Select, Spin, Dropdown, Space, Menu } from "antd"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser } from "@fortawesome/free-solid-svg-icons"
import API from "../../services"
import { Confirm } from "notiflix"
import moment from "moment"

import LoginEpicor from "./loginEpicor"
import { RibbonCard } from "@/components/ui/ribbon-card"
import { Badge } from "@/components/ui/badge"

const PendingEpicor = () => {
  const isAuthenticated = useIsAuthenticated()
  const [pending, setPending] = useState([])
  const [loading, setLoading] = useState(true)
  const [filterType, setFilterType] = useState(null)
  const [typeOptions, setTypeOptions] = useState([])
  const [epicorUser, setEpicorUser] = useState(null)

  const [showLoginModal, setShowLoginModal] = useState(false)

  const { Option } = Select
  const navigate = useNavigate()

  function parseJwt(token) {
    const base64Url = token.split(".")[1] // ambil payload
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    )
    return JSON.parse(jsonPayload)
  }

  const getPending = token => {
    setLoading(true)

    const epicorToken = localStorage.getItem("epicor_token")
    const resultsEncodeToken = parseJwt(localStorage.getItem("epicor_token"))
    setEpicorUser(resultsEncodeToken)

    if (!epicorToken) {
      console.warn("Token Epicor tidak ditemukan!")
      setShowLoginModal(true)
      return
    }

    const headers = HeaderFarms(token)
    const fullHeaders = {
      ...headers,
      token: epicorToken,
    }

    API.GetEpicorPending(fullHeaders, resultsEncodeToken.username || "-")
      .then(res => {
        const data = res
        setPending(data)

        // Ambil unique type
        const types = [...new Set(data.map(item => item.type).filter(Boolean))]

        setTypeOptions(types)
        setLoading(false)
      })
      .catch(err => {
        if (err?.response?.status === 401 && err?.response?.data?.error === "Invalid or expired token") {
          console.warn("Token expired atau tidak valid")
          localStorage.removeItem("epicor_token")
          setShowLoginModal(true)
        } else {
          console.error(err)
          Report.warning("Oops.. something wrong", "Sorry, this application is experiencing problems", "Okay")
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const goDetail = data => {
    const type = data?.type.split("-")[0].toLowerCase().trim()
    navigate(`/epicor/${type}/${data.number}`)
  }

  const handleFilterChange = value => {
    if (value === "__ALL__") {
      setFilterType(null)
    } else {
      setFilterType(value)
    }
  }

  function handleLogout() {
    navigate("/home")
    localStorage.removeItem("epicor_token")
  }

  function Logout() {
    Confirm.show(
      "Logout",
      "Are you sure want Logout Session?",
      "Yes",
      "No",
      () => {
        handleLogout()
      },
      {}
    )
  }

  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={Logout}>
        <a>{`Logout ${epicorUser?.username}`}</a>
      </Menu.Item>
    </Menu>
  )

  useEffect(() => {
    const fetchData = async () => {
      const epicorToken = localStorage.getItem("epicor_token")

      if (!epicorToken) {
        setShowLoginModal(true) // tampilkan modal login
        setLoading(false)
        return
      }
      try {
        const accessToken = await requestToken()
        if (!accessToken) {
          return
        }
        getPending(accessToken)
      } catch (error) {
        console.error("❌ Gagal mengambil data:", error)
      }
    }

    fetchData()
  }, [isAuthenticated])

  const filteredPending = filterType ? pending.filter(item => item.type === filterType) : pending

  const renderVariant = status => {
    switch (status) {
      case "Waiting Approval":
        return "warning"
      case "Approved":
        return "success"
      case "Reject":
        return "error"
      default:
        return "black"
    }
  }

  return (
    <>
      <Navbar title="View" back={true} subtitle="Epicor Pending" navigate="/home" />
      <div className="container-fluid white-back-cr" style={{ minHeight: 400 }}>
        {/* Modal Login section */}
        <LoginEpicor
          visible={showLoginModal}
          onClose={async token => {
            setShowLoginModal(false)
            if (token) {
              try {
                const accessToken = await requestToken()
                if (accessToken) {
                  getPending(accessToken)
                }
              } catch (err) {
                console.error("❌ Gagal fetch setelah login:", err)
              }
            }
          }}
        />

        <ImportantInfo />

        {/* profile epicor section */}
        <div className="d-flex justify-content-end align-items-center px-3">
          <Dropdown overlay={menu} trigger={["click"]}>
            <div className="profile-link-epicor">
              <Space>
                <div className="profile-section-epicor d-flex align-items-center">
                  <FontAwesomeIcon icon={faUser} className="profile-icon-epicor" style={{ color: "#7b809a" }} />
                  <div className="fw-bolder mx-3" style={{ fontSize: "9px" }}>
                    {`Epicor : ${epicorUser?.username}` || "-"}
                  </div>
                </div>
              </Space>
            </div>
          </Dropdown>
        </div>

        <div className="container" style={{ alignSelf: "center" }}>
          <div className="row mb-3">
            <div className="col" />
            <div className="col-md-6 d-flex justify-content-end">
              <label style={{ marginRight: 10, marginTop: 5 }}>Filter</label>
              <Select allowClear placeholder="Filter by type" style={{ width: 200 }} onChange={handleFilterChange} value={filterType || "__ALL__"}>
                <Option value="__ALL__">Show All</Option>
                {typeOptions.map((type, i) => (
                  <Option key={i} value={type}>
                    {type}
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="row">
            <div className="col-md-10 offset-md-1">
              {filteredPending.length > 0 ? (
                filteredPending.map((data, index) => {
                  if (!data) return null

                  let ribbonColor
                  switch (data?.StatusDesc) {
                    case "Approved":
                      ribbonColor = "blue"
                      break
                    case "Reject":
                      ribbonColor = "red"
                      break
                    case "Closed":
                      ribbonColor = "green"
                      break
                    default:
                      ribbonColor = "#FF9900"
                  }

                  return (
                    <Fragment key={index}>
                      <RibbonCard variant={renderVariant(data?.status || data?.StatusDesc || "-")} position="bottom-right" ribbon={data?.status || data?.StatusDesc || "-"} className="mb-3 cursor-pointer" onClick={() => goDetail(data)}>
                        <div className="flex items-center justify-between gap-4 mb-1">
                          <span className="text-sm title-epicor">{data.type}</span>
                          <Badge variant="success">
                            <span className="mb-0">{`Number : ${data.number || "-"}`}</span>
                          </Badge>
                        </div>

                        <div className="flex flex-col items-start gap-2">
                          <p className="text-xs">
                            {data.requestor}
                          </p>
                          <p className="text-[10px] text-gray-400">
                            {moment(data.request_date).format("YYYY-MM-DD")}
                          </p>
                        </div>
                      </RibbonCard>
                    </Fragment>
                    // <Fragment key={index}>
                    //   <Badge.Ribbon
                    //     color={ribbonColor}
                    //     text={data?.status || data?.StatusDesc || "Unknown"}
                    //   >
                    //     <div
                    //       className="list-style-epicor p-3 px-4 mb-3"
                    //       onClick={() => goDetail(data)}
                    //     >
                    // <div className="d-flex justify-content-between align-items-center mb-1">
                    //   <span className="fs-7 title-epicor">
                    //     {data.type}
                    //   </span>
                    //   <span className="fs-7  mb-0">
                    //     {`Number : ${data.number || "-"}`}
                    //   </span>
                    // </div>

                    //       <div className="d-flex justify-content-between">
                    //         <p className="fs-7" style={{ fontSize: 12 }}>
                    //           {data.requestor}
                    //         </p>
                    //       </div>
                    //       <div className="hour d-flex justify-content-between m-0">
                    //         <p
                    //           className="fs-7"
                    //           style={{ color: "#B7B7B7", fontSize: 11 }}
                    //         >
                    //           {moment(data.request_date).format("YYYY-MM-DD")}
                    //         </p>
                    //       </div>
                    //     </div>
                    //   </Badge.Ribbon>
                    // </Fragment>
                  )
                })
              ) : !loading ? (
                <Empty className="mt-5" />
              ) : null}
              {loading && (
                <div className="fs-6 text-center mt-5" style={{ color: "#B7B7B7" }}>
                  <Spin size="large" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default PendingEpicor
